import React, { type FC } from 'react';
import { useStyleContextState } from '../../../../../ReactSharedScripts/modules/styleContext';
import { useTranslationAPI } from '../../../../../ReactSharedScripts/modules/translations';
import { useToolNavigationRoleSwitcherProvider } from '../../../../../ReactSharedScripts/modules/toolNavigation_new/components/ToolNavigationRoleSwitcherProvider';
import { codes } from '../../../../../ReactSharedScripts/data/translations/codes';
import { User } from '../../../../../ReactSharedScripts/components/Icons/User';
import { Gear } from '../../../../../ReactSharedScripts/components/Icons/Gear';
import { PaddingBox } from '../../../../../ReactSharedScripts/components/PaddingBox';
import classes from '../styles/index.module.css';
import { ToolNavigationActiveLine } from '../../../../../ReactSharedScripts/modules/toolNavigation_new/components/ToolNavigationActiveLine';
import { closeActiveTooltip } from '../../../../../ReactSharedScripts/components/TooltipBtn';

export const ToolNavigationCollapsedRoleSwitcherTooltip: FC = () => {
	const { mainColor } = useStyleContextState();
	const { translate } = useTranslationAPI();
	const { hasUserNavigation, hasAdminNavigation, switchToUser, switchToAdmin, isAdmin } =
		useToolNavigationRoleSwitcherProvider();

	return (
		<PaddingBox vrTiny>
			{hasUserNavigation && (
				<button
					className={classes.switcherButton}
					type='button'
					onClick={() => {
						switchToUser();
						closeActiveTooltip();
					}}
					data-tool-navigation-list-type='user'
				>
					{!isAdmin && <ToolNavigationActiveLine />}
					<User
						className={classes.switcherButtonIcon}
						fill={isAdmin ? undefined : mainColor}
					/>
					<span>{translate(codes.user.singular)}</span>
				</button>
			)}
			{hasAdminNavigation && (
				<button
					className={classes.switcherButton}
					type='button'
					onClick={() => {
						switchToAdmin();
						closeActiveTooltip();
					}}
					data-tool-navigation-list-type='admin'
				>
					{isAdmin && <ToolNavigationActiveLine />}
					<Gear
						className={classes.switcherButtonIcon}
						fill={isAdmin ? mainColor : undefined}
					/>
					<span>{translate(codes.navigation.admin)}</span>
				</button>
			)}
		</PaddingBox>
	);
};
